<template>
  <div class="ProcessExceptionPreview">
    <el-tabs :value="tabActive">
      <el-tab-pane name="first" label="异常信息">
        <div>
          <el-button type="primary" @click="printPage">打印</el-button>
        </div>
        <div class="WrongInfoPage">
          <h1 class="mainTitle">eMES异常处理通知单</h1>
          <div class="title"/>
          <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
            <tr>
              <td class="tableLabel">系统编号:</td>
              <td>{{processException.billNo}}</td>
              <td class="tableLabel">开单人:</td>
              <td>{{processException.creatorName}}</td>
              <td class="tableLabel">登记日期:</td>
              <td>{{processException.createTime}}</td>
            </tr>
            <tr>
              <td class="tableLabel">反馈部门:</td>
              <td>{{processException.feedbackDepart}}</td>
              <td class="tableLabel">反馈人:</td>
              <td>{{processException.feedbackPerson}}</td>
              <td class="tableLabel">出厂编号:</td>
              <td>{{processException.factoryNo}}</td>
            </tr>
            <tr>
              <td class="tableLabel">客户名称:</td>
              <td>{{processException.customerName}}</td>
              <td class="tableLabel">物料号:</td>
              <td>{{processException.materialNo}}</td>
              <td class="tableLabel">物料描述:</td>
              <td>{{processException.materialName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">当批总数:</td>
              <td>{{processException.batchNum}}</td>
              <td class="tableLabel">不良数量:</td>
              <td>{{processException.badNum}}</td>
              <td class="tableLabel">误工工时:</td>
              <td>{{processException.workTime}}</td>
            </tr>
            <tr>
              <td class="tableLabel">一体机/板卡序列号:</td>
              <td colspan="5">{{processException.serialNo}}</td>
            </tr>
          </table>

          <h1 class="mainTitle" style="font-size: 16px;text-align: left;">问题描述</h1>
          <div class="title"/>
          <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
            <tr>
              <td class="tableLabel">基准:</td>
              <td>{{processException.standards}}</td>
            </tr>
            <tr>
              <td class="tableLabel">实际:</td>
              <td>{{processException.problemDesc}}</td>
            </tr>
            <tr>
              <td class="tableLabel">备注:</td>
              <td>{{processException.note}}</td>
            </tr>
            <tr>
              <td class="tableLabel">是否需要对当前问题处理:</td>
              <td>{{processException.isHandle ? "是" : "否"}}</td>
            </tr>
            <tr v-if="processException.isHandle">
              <td class="tableLabel">处理部门接口人:</td>
              <td>{{processException.handleName}}</td>
            </tr>
            <tr>
              <td class="tableLabel">质量部接口人:</td>
              <td>{{processException.qualityDirecterName}}</td>
            </tr>
          </table>
          <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">附件</div>
          <el-table :data="processException.accessories">
            <el-table-column type="index" label="序号" width="50" align="center"/>
            <el-table-column label="附件名称" align="left" prop="fileName"/>
            <el-table-column label="备注" align="left" prop="note"/>
            <el-table-column label="操作" align="center" width="90">
              <template slot-scope="scope">
                <el-button type="primary" @click="downloadFile(scope.row.filePath)">查看附件</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <handle-detail :bill-id="billId" :bill-type="billType" sequ-id="-1"/>
      </el-tab-pane>
      <el-tab-pane name="second" label="处理部门">
        <div class="title"/>
        <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">不合格品处理方式:</td>
            <td>{{processException.processMode}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="third" label="质量判责">
        <div class="title"/>
        <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">质量判责结果:</td>
            <td>{{processException.judgmentResult}}</td>
          </tr>
          <tr>
            <td class="tableLabel">责任部门:</td>
            <td>{{processException.responsibleDepartment}}</td>
          </tr>
          <tr>
            <td class="tableLabel">供应商名称:</td>
            <td>{{processException.supplierName}}</td>
          </tr>
        </table>
      </el-tab-pane>
      <el-tab-pane name="fourth" label="维修处理结果">
        <table class="ProcessExceptionTable" style="width: 100%" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">检查结果:</td>
            <td>{{processException.inspectionResult}}</td>
          </tr>
          <tr>
            <td class="tableLabel">处理方法:</td>
            <td>{{processException.solution}}</td>
          </tr>
          <tr>
            <td class="tableLabel">故障模块分类:</td>
            <td>{{processException.faultType}}</td>
          </tr>
          <tr>
            <td class="tableLabel">电机问题类型:</td>
            <td>{{processException.problemType}}</td>
          </tr>
          <tr>
            <td class="tableLabel">原因分析:</td>
            <td>{{processException.causeInvestigation}}</td>
          </tr>
          <tr>
            <td class="tableLabel">责任判定:</td>
            <td>{{processException.responsibleDecision}}</td>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>
  </div> 
</template>

<script>
  import HandleDetail from "@/views/workFlow/HandleDetail";
  export default {
    name:"ProcessExceptionsPreview",
    components:{ HandleDetail},
    data() {
      return {
        billId:"",
        billType:"24",
        tabActive:"first",
        processException:[],
      };
    },
    created() {
      console.log(this.$route.query.billId);
      this.billId = this.$route.query.billId;
      this.getData();
    },
    methods:{
      getData() {
        this.$http.get("basic",`processExceptions/${this.billId}`).then((res)=>{
          console.log(res);
          this.processException = res;
        });
      },
      downloadFile(path) {
        let a = document.createElement("a");
        a.href = "http://emes.stepelectric.com" + path;
        a.target = "_blank";
        a.download = path;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
      printPage() {
        var printPage = document.querySelector(".WrongInfoPage").innerHTML;
        var oldPage = document.body.innerHTML;
        document.body.innerHTML = printPage;
        window.print();
        window.location.reload();
      },
    },
  };
</script>

<style lang="scss">
  .ProcessExceptionTable {
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border-left: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }
  .ProcessExceptionTable1{
    font-family: verdana, arial, sans-serif;
    font-size: 11px;
    color: #333333;
    border-left: 1px solid #ebeef5;
  }
  table.ProcessExceptionTable1 th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #ebeef5;
    background-color: #f4f7fa;
  }
  table.ProcessExceptionTable1 td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #ebeef5;
    border-left: none;
    border-bottom: none;
  }
  table.ProcessExceptionTable th {
    text-align: left;
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #ebeef5;
    background-color: #f4f7fa;
  }
  table.ProcessExceptionTable td {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #ebeef5;
    border-left: none;
    border-bottom: none;
  }
  .tableLabel {
    width: 15%;
    text-align: right;
    background-color: #d1e6f5 !important;
  }
  .title {
   font-size:12px;
   font-weight:550;
   border-bottom:1px solid #ccc;
   width:100%;
   margin:5px 0 5px;
  }
  .mainTitle {
    font-size: 20px;
    line-height: 20px;
    text-align: center;
  }
</style>